import React, { useState, useEffect } from "react";
import {
  checkCashUser,
  CreateGames,
  deleteGameImage,
  editGame,
  gameImageUpload,
  getGameFromSlug,
  getVanityUrl,
  storeTempImage,
} from "../../api/user";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPlus } from "@fortawesome/free-solid-svg-icons";
import { event } from "../../utils/event";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";
import { BASE_URL, GAME_URL } from "../../config/api";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ToggleSwitch from "./ToggleSwitch";
import { useNavigate, useLocation } from "react-router-dom";
import "../Game/game.css";
import { useParams } from "react-router-dom";
import { IconEyeClose, IconEyeOpen } from "../../icons/icons";

const AddGame = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  const [imgurl, setImgUrls] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const isMobileView = document.body.clientWidth <= 768;
  const flutter = localStorage.getItem("isFlutterInAppWebViewReady");
  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [existingVanityUrls, setExistingVanityUrls] = useState([]);
  const [vanityUrlError, setVanityUrlError] = useState("");
  const [showError, setShowError] = useState(false); // Error state
  const navigate = useNavigate();
  const { slug } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const userId = userInfo.id;
  const [gameId, setGameId] = useState(null); // Add state to store game_id
  const [editVanityUrl, setEditVanityUrl] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [cashUserData, setCashUserData] = useState(null);

  const resetTime = (date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const fetchVanityUrl = async (controller) => {
    try {
      const response = await getVanityUrl({ signal: controller.signal });
      if (response?.status === 200) {
        setExistingVanityUrls(response.data.data);
      } else {
        console.log("Error occurred");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.log(error);
      }
    } finally {
    }
  };

 const fetchCashUser = async (controller) => {
    if (!userId) {
      setErrors("User ID not found");
      setLoading(false);
      return;
    }

    try {
      const response = await checkCashUser({ id: userId});
      if (response?.status === 200) {
        setCashUserData(response.data);
      } else {
        console.log("Error occurred");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        setErrors(error);
        console.error("Error fetching cash user:", error);
      }
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const controller = new AbortController();
    fetchVanityUrl(controller);
    fetchCashUser(controller);

    return () => {
      controller.abort();
      console.log("Clean up: fetch aborted");
    };
  }, []);

  useEffect(() => {
    const fetchGameData = async () => {
      if (slug) {
        // If slug exists, it's edit mode
        setIsEditMode(true);
        try {
          const response = await getGameFromSlug({ slug });
          if (response) {
            const gameData = response?.data?.data;

            const todayDate = resetTime(new Date());
            const leagueEndDate = resetTime(new Date(gameData.end_date));

            if (todayDate > leagueEndDate) {
              toast.error(
                "You can edit this game now because game is finished"
              );
              navigate("/contest/my-games", { state: { viewMode: "member" } });
            }

            if (userId !== gameData.user_id) {
              toast.error("You can't edit a game");
              navigate("/contest");
            }

            // Replace `null` values in gameData with defaults
            const processedGameData = {
              ...gameData,
              description: gameData.description || "",
              start_date: gameData.start_date || "", // Default to empty string
              end_date: gameData.end_date || "", // Default to empty string
              game_type: gameData.game_type || "public", // Default to 'public'
              reward: gameData.reward || "", // Default to empty string
              vanity_url: gameData.vanity_url || "", // Default to empty string
              sponsor: gameData.sponsor || "", // Default to empty string
              credit: gameData.credit || "", // Default to empty string
              join_after_start: gameData.join_after_start ?? false, // Default to false
              private_portfolio: gameData.private_portfolio ?? false, // Default to false
            };

            setFormData({
              ...processedGameData,
              startDate: processedGameData.start_date.slice(0, 10), // Format to 'YYYY-MM-DD'
              endDate: processedGameData.end_date.slice(0, 10), // Format to 'YYYY-MM-DD'
              gameType: processedGameData.game_type,
              joinAfterStart: processedGameData.join_after_start,
              privatePortfolio: processedGameData.private_portfolio,
              cashLeague: processedGameData.is_cash_prize_league,
              cash_prize_amount:processedGameData.cash_prize_amount
            });

            console.log(processedGameData.game_image, "image from backend");
            setGameId(processedGameData.id);
            setEditVanityUrl(processedGameData.vanity_url);

            if (Array.isArray(processedGameData.game_image)) {
              const formattedImages = processedGameData.game_image.map(
                (img) => ({
                  id: img.id,
                  image: img.image,
                  blob: null,
                  preview: img.image, // Use the backend image as the preview
                })
              );
              setImages(formattedImages);
            }
          }
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        // Clear form for add mode
        setIsEditMode(false);
      }
    };

    fetchGameData(); // Call the async function
  }, [slug]);

  // useEffect(() => {
  //   const handleCustomProfileEvent = async (event) => {
  //     if (event?.detail?.imageGame) {
  //       const rawData = event.detail.imageGame; // e.g., [temp/20241213/LrSD25IiOfNzN4muxXRg-1734072016.jpg]

  //       // Split and clean the file paths
  //       const files = rawData.split(",");
  //       const unescapedData = files.map((val) =>
  //         val.replace(/^\[|\]$/g, "").trim()
  //       );

  //       const imageUrls = []; // To store the preview URLs

  //       for (const filePath of unescapedData) {
  //         try {
  //           // Use the storeTempImage function to get the public URL of the image
  //           const publicUrl = await storeTempImage(filePath);

  //           if (publicUrl) {
  //             imageUrls.push({ preview: publicUrl });
  //           }
  //         } catch (error) {
  //           console.error(`Error handling file ${filePath}:`, error);
  //         }
  //       }

  //       // Update state with new images
  //       setImages((prevImages) => [...prevImages, ...imageUrls]);
  //     }
  //   };

  //   // Add the event listener for the custom event
  //   window.addEventListener("myCustomPostEvent", handleCustomProfileEvent);

  //   // Cleanup the event listener on unmount
  //   return () => {
  //     window.removeEventListener("myCustomPostEvent", handleCustomProfileEvent);
  //   };
  // }, []);

  // useEffect(() => {
  //   const handleCustomProfileEvent = (event) => {
  //     if (event?.detail?.imagePost) {
  //       const rawData = event.detail.imageGame;
  //       const files = rawData.split(",");
  //       const unescapedData = files.map((val) =>
  //         val.replace(/^\[|\]$/g, "").trim()
  //       );
  //       const baseUrl = `${BASE_URL}/storage`;

  //       const imageUrls = unescapedData.map((image) => ({
  //         preview: baseUrl + image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
  //       }));

  //     const imageUrls1 = unescapedData.map((image) => ({
  //       image: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
  //       preview: `${baseUrl}/${image.replace(/\[|\]/g, "").replaceAll(`"`, "")}`,
  //     }));

  //     const alertData = {
  //       rawData,
  //       baseUrl,
  //       imageUrls,
  //       imageUrls1,
  //     };
  //     alert(`Debug Alert:\n${JSON.stringify(alertData, null, 2)}`);

  //     setImages((prevImages) => [...prevImages, ...imageUrls]);
  //     setImgUrls((prevImages) => [...prevImages, ...imageUrls1]);
  //     }
  //   };

  //   window.addEventListener("myCustomPostEvent", handleCustomProfileEvent);
  //   return () => {
  //     window.removeEventListener("myCustomPostEvent", handleCustomProfileEvent);
  //   };
  // }, [user, window.addEventListener]);

  //this
  useEffect(() => {
    const handleCustomProfileEvent = (event) => {
      if (event?.detail?.imageGame) {
        // Extract raw data
        const rawData = event.detail.imageGame;
        const files = rawData.split(","); // Split by comma
        const unescapedData = files.map((val) =>
          val.replace(/^\[|\]$/g, "").trim()
        ); // Clean up brackets

        const baseUrl = `${BASE_URL}/storage`; // Define base URL for images

        // Generate the image URLs for both image and preview
        const imageUrls = unescapedData.map((image) => {
          // Clean the image path: remove '/public' and format the path
          const cleanedImage = image
            .replace("/public", "")
            .replace(/\[|\]|\s|"/g, "")
            .trim();
          return {
            preview: `${baseUrl}${cleanedImage}`, // Construct preview URL
          };
        });

        const imageUrls1 = unescapedData.map((image) => {
          // Clean the image path: remove '/public' and format the path
          const cleanedImage = image
            .replace("/public", "")
            .replace(/\[|\]|\s|"/g, "")
            .trim();
          return {
            // image: `${baseUrl}${cleanedImage}`, // Construct image URL
            image: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
            preview: `${baseUrl}${cleanedImage}`, // Construct preview URL
          };
        });

        // Debugging: show alert with structured data
        const alertData = {
          rawData,
          baseUrl,
          unescapedData,
          imageUrls,
          imageUrls1,
        };

        // Update the state with generated URLs
        setImages((prevImages) => [...prevImages, ...imageUrls]);
        setImgUrls((prevImages) => [...prevImages, ...imageUrls1]);
      }
    };

    // Add and clean up event listener
    window.addEventListener("myCustomPostEvent", handleCustomProfileEvent);
    return () => {
      window.removeEventListener("myCustomPostEvent", handleCustomProfileEvent);
    };
  }, [user, window.addEventListener]);

  // useEffect(() => {
  //   const handleCustomProfileEvent = (event) => {
  //     if (event?.detail?.imageGame) {
  //       // Extract raw data
  //       const rawData = event.detail.imageGame;
  //       const files = rawData.split(","); // Split by comma
  //       const unescapedData = files.map((val) => val.replace(/^\[|\]$/g, "").trim()); // Clean up brackets

  //       const baseUrl = `${BASE_URL}/storage`; // Define base URL for images

  //       // Generate the image URLs for both image and preview
  //       const imageUrls = unescapedData.map((image) => {
  //         // Clean the image path: remove '/public' and format the path
  //         const cleanedImage = image.replace("/public", "").replace(/\[|\]|\s|"/g, '').trim();
  //         return {
  //           preview: `${baseUrl}${cleanedImage}`, // Construct preview URL
  //         };
  //       });

  //       const imageUrls1 = unescapedData.map((image) => {
  //         // Clean the image path: remove '/public' and format the path
  //         const cleanedImage = image.replace("/public", "").replace(/\[|\]|\s|"/g, '').trim();
  //         return {
  //         //  image: `${baseUrl}${cleanedImage}`, // Construct image URL
  //           image: image.replace(/\[|\]/g, "").replaceAll(`"`, ""),
  //           preview: `${baseUrl}${cleanedImage}`, // Construct preview URL
  //         };
  //       });

  //       // Debugging: show alert with structured data
  //       const alertData = {
  //         rawData,
  //         baseUrl,
  //         unescapedData,
  //         imageUrls,
  //         imageUrls1,
  //       };
  //       alert(`Debug Alert:\n${JSON.stringify(alertData, null, 2)}`);

  //       // Update the state with generated URLs
  //       setImages((prevImages) => [...prevImages, ...imageUrls]);
  //       setImgUrls((prevImages) => [...prevImages, ...imageUrls1]);
  //     }
  //   };

  //   // Manually simulate the event for testing
  //   const simulatedEvent = {
  //     detail: {
  //       imageGame: '[/public/temp/20241216/owtylrB8PODmlQmQ7uwz-1734337496.svg]',
  //     },
  //   };

  //   handleCustomProfileEvent(simulatedEvent);

  //   // Add event listener for testing (optional if required for further dynamic events)
  //   window.addEventListener("myCustomPostEvent", handleCustomProfileEvent);
  //   return () => {
  //     window.removeEventListener("myCustomPostEvent", handleCustomProfileEvent);
  //   };
  // }, []);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    reward: "",
    sponsor: "",
    gameType: "public",
    password: "",
    credit: "",
    vanity_url: "",
    cash_prize_amount:"",
    joinAfterStart: false,
    privatePortfolio: false,
    cashLeague: false
  });

  const [errors, setErrors] = useState({});

  const handleDeleteGameImage = async (gameId, imageId) => {
    try {
      // Create the body object
      const body = {
        game_id: gameId,
        image_id: imageId,
      };

      // Call the deleteGameImage API
      const response = await deleteGameImage(body);

      // Log the response and handle success
      if (response?.status === 200) {
        console.log(response.data, "Image deleted successfully");
        toast.success("Image deleted successfully");

        // Update the state to remove the deleted image
        setImages((prevImages) =>
          prevImages.filter((image) => image.id !== imageId)
        );
      } else {
        console.error("Failed to delete image:", response?.data?.message);
        toast.error("Failed to delete the image");
      }
    } catch (error) {
      console.error("Error deleting the image:", error);
      toast.error("An error occurred while deleting the image");
    }
  };

  const handleRemoveImage = (index) => {
    if (slug) {
      // Get the image ID for deletion before updating state
      const imageToDelete = images[index]?.id; // Access the image object at the given index
      console.log(imageToDelete, "Image ID to delete from database");
      console.log(gameId);

      const userConfirmed = window.confirm(
        "Are you sure you want to delete this Upload?"
      );

      if (userConfirmed) {
        if (imageToDelete && gameId) {
          handleDeleteGameImage(gameId, imageToDelete); // Call the function with gameId and imageId
        }

        setImages((prevImages) => {
          const updatedImages = prevImages.filter((_, i) => i !== index); // Filter out the image at the given index
          console.log(updatedImages, "Updated images inside setter");
          return updatedImages;
        });
      }
      console.log(images, "new Images");
    }
    console.log(index, "index1");
    const updatedImages = [...images];
    console.log(updatedImages, "img");
    const deletedImageId = updatedImages[index]?.id;
    console.log(deletedImageId, "dimg");
    updatedImages.splice(index, 1);
    setImages(updatedImages);
    console.log(updatedImages, "uimg");
    const imgs = imgurl.filter((val, index1) => index1 !== index);
    setImgUrls(imgs);
    console.log(imgs, "indexfinaql");
    setDeletedImageIds((prevIds) => {
      const newIds = [...prevIds, deletedImageId];
      return newIds;
    });
  };

  const handleImageUpload = async (e) => {
    const selectedFiles = e.target.files;
    const allowedExtensionsRegex =
      /\.(jpg|jpeg|png|svg|mp4|mov|avi|wmv|webp|gif)$/i;

    // for (let i = 0; i < selectedFiles.length; i++) {
    //   const file = selectedFiles[i];

    //   const maxSize = 512 * 1024 * 1024;
    //   if (!allowedExtensionsRegex.test(file?.name)) {
    //     toast.error("You can only select either an image or a video!");
    //     return;
    //   }
    //   if (file?.size > maxSize) {
    //     toast.error("File size should not be greater that 512 Mb!");
    //     return;
    //   }
    // }

    const imageMaxSize = 2 * 1024 * 1024; // 2MB in bytes
    const videoMaxSize = 20 * 1024 * 1024; // 20MB in bytes

    for (let i = 0; i < selectedFiles.length; i++) {
      const file = selectedFiles[i];

      // Validate file extension
      if (!allowedExtensionsRegex.test(file?.name)) {
        toast.error("Sorry,Your upload extension is not allowed !!");
        return;
      }

      // Determine MIME type for separate size validation
      const mimeType = file.type;

      if (mimeType.startsWith("image/") && file?.size > imageMaxSize) {
        toast.error("Image size should not exceed 2 MB!");
        return;
      }

      if (mimeType.startsWith("video/") && file?.size > videoMaxSize) {
        toast.error("Video size should not exceed 20 MB!");
        return;
      }
    }
    const newImages = Array.from(selectedFiles)
      .slice(0, 5 - images.length)
      .map((file) => ({
        id: null,
        image: null,
        blob: file,
        preview: URL.createObjectURL(file),
      }));
    setImages((prevImages) => [...prevImages, ...newImages]);

    try {
      setLoading(true);

      const response = await gameImageUpload(newImages);
      if (response) {
        const imageArray = response.data.data.map((path) => ({ image: path }));
        const imageJsonString = imageArray;
        setImgUrls((prevImages) => [...prevImages, ...imageJsonString]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setShowError(true);
      toast.error(
        "Failed to upload!! Failed because you upload extesnion not allowed or a upload size exceed"
      );
      console.error("Error:", error);
    }
  };

  const handlePlayClick = (index) => {
    const video = document.querySelector(`#video-${index}`);
    const playButton = document.querySelector(`#play-button-${index}`);

    if (currentVideoIndex !== null && currentVideoIndex !== index) {
      // Pause the current video if another video is clicked
      const currentVideo = document.querySelector(
        `#video-${currentVideoIndex}`
      );
      currentVideo.pause();
    }

    if (video.paused) {
      video.play();
      setCurrentVideoIndex(index);
      playButton.style.display = "none";

      video.onended = () => {
        playButton.style.display = "block";
      };
    } else {
      video.pause();
      playButton.style.display = "block"; // Show play button if video is paused
      setCurrentVideoIndex(null); // Reset current video index
    }
  };

  // Get today's date in the format 'YYYY-MM-DD' for the date picker.
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().slice(0, 10); // Format 'YYYY-MM-DD'
  };

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  const generateBaseVanityUrl = (inputTitle) => {
    // Generate the base vanity URL and trim any trailing hyphens
    return inputTitle
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/[^\w-]+/g, "") // Remove non-alphanumeric characters except hyphens
      .replace(/-+$/, ""); // Trim trailing hyphens
  };

  const ensureUniqueVanityUrl = (baseVanityUrl) => {
    let formattedUrl = baseVanityUrl;

    // Ensure uniqueness by checking against existing vanity URLs
    while (existingVanityUrls.includes(formattedUrl)) {
      const randomSuffix = Math.random().toString(36).substring(2, 7); // Generate a random 5-character string
      formattedUrl = `${baseVanityUrl}${randomSuffix}`; // Do not add a hyphen automatically
    }

    return formattedUrl;
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;

    // Update form data and generate vanity URL when title changes
    setFormData((prevData) => {
      const newData = {
        ...prevData,
        [name]: updatedValue,
      };

      if (name === "vanity_url") {
        const baseVanityUrl = generateBaseVanityUrl(prevData.title);

        // Ensure the base portion is maintained and only the suffix can be edited
        if (value.startsWith(baseVanityUrl)) {
          newData.vanity_url = value;
          setVanityUrlError(
            existingVanityUrls.includes(value)
              ? `The vanity URL "${value}" is already taken.`
              : ""
          );
        } else {
          // If the base is being erased or modified, revert to the previous state
          newData.vanity_url = prevData.vanity_url;
        }
      } else if (name === "title") {
        // If title is updated, generate a new base vanity URL
        const baseVanityUrl = generateBaseVanityUrl(value);
        if (editVanityUrl === baseVanityUrl) {
          newData.vanity_url = editVanityUrl;
        } else {
          newData.vanity_url = ensureUniqueVanityUrl(baseVanityUrl);
        }
        setVanityUrlError(""); // Clear error when title changes
      }

      return newData;
    });
  };

  // Separate handler for Quill editor
  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!formData.title) validationErrors.title = "Game title is required.";
    if (!formData.startDate)
      validationErrors.startDate = "Start date is required.";
    if (!formData.endDate) {
      validationErrors.endDate = "End date is required.";
    } else if (new Date(formData.endDate) < new Date(formData.startDate)) {
      validationErrors.endDate = "End date must be after start date.";
    }

    // if (!formData.reward || formData.reward <= 0) {
    //   validationErrors.reward = "Reward must be a positive number.";
    // }

    // if (!formData.sponsor) validationErrors.sponsor = "Sponsor is required.";
    // if (!formData.credit || formData.credit < 0) {
    //   validationErrors.credit = "Credit must be a positive number.";
    // }

    if (formData.gameType === "private" && !formData.password) {
      validationErrors.password = "Password is required for private game.";
    } else if (formData.password && formData.password.length < 6) {
      validationErrors.password =
        "Password must be at least 6 characters long.";
    }

    // Vanity URL uniqueness check
    //  if(isEditMode){
    //      alert(editVanityUrl);
    //      return;
    //  }else{
    //   if (existingVanityUrls.includes(formData.vanity_url)) {
    //     validationErrors.vanity_url = `The vanity URL "${formData.vanity_url}" is already taken.`;
    //   }
    //  }

    // if (
    //   existingVanityUrls.includes(formData.vanity_url) &&
    //   (!isEditMode || formData.vanity_url === editVanityUrl)
    // ) {
    //   validationErrors.vanity_url = `The vanity URL "${formData.vanity_url}" is already taken.`;
    // }

    // If in edit mode, remove the current `editVanityUrl` from `existingVanityUrls`
    let filteredVanityUrls = [...existingVanityUrls];
    if (isEditMode) {
      filteredVanityUrls = filteredVanityUrls.filter(
        (url) => url !== editVanityUrl
      );
    }

    // Validate if the `vanity_url` is still unique
    if (filteredVanityUrls.includes(formData.vanity_url)) {
      validationErrors.vanity_url = `The vanity URL "${formData.vanity_url}" is already taken.`;
    }

    return validationErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    let gameData = {
      title: formData.title,
      description: formData.description,
      start_date: formData.startDate,
      end_date: formData.endDate,
      reward: formData.reward,
      vanity_url: formData.vanity_url,
      sponsor: formData.sponsor,
      game_type: formData.gameType,
      password: formData.gameType === "private" ? formData.password : null,
      credit: formData.credit,
      join_after_start: formData.joinAfterStart,
      private_portfolio: formData.privatePortfolio,
      is_cash_prize_league: formData.cashLeague,
      cash_prize_amount:formData.cash_prize_amount

    };

    // return;
    if (isEditMode) {
      gameData.id = gameId;
    }
    if (imgurl.length > 0) {
      console.log(imgurl, "img urls are");

      gameData.image_json = JSON.stringify(imgurl);
    } else {
      gameData.imageJsonString = "";
    }

    if (isEditMode) {
      try {
        const response = await editGame(gameData);
        if (response.status === 200) {
          toast.success("League is edited successfully");
          setFormData({
            title: "",
            description: "",
            startDate: "",
            endDate: "",
            reward: "",
            vanity_url: "",
            sponsor: "",
            gameType: "public",
            password: "",
            credit: "",
            cash_prize_amount:"",
            joinAfterStart: false,
            privatePortfolio: false,
            cashLeague: false,
          });
          setImages([]);
          setErrors({});
          // navigate("/contest/my-games");
          localStorage.removeItem("imageGame");
          navigate("/contest/my-games", { state: { viewMode: "member" } });
        } else {
          throw new Error("Something went wrong");
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
        console.error("Failed to edit game", error);
      }
    } else {
      try {
        const response = await CreateGames(gameData);
        if (response.status === 200) {
          toast.success(
            "Thanks for submitting your game! It’s under review and we’ll notify you once it’s approved for publishing."
          );
          setFormData({
            title: "",
            description: "",
            startDate: "",
            endDate: "",
            reward: "",
            vanity_url: "",
            sponsor: "",
            gameType: "public",
            password: "",
            credit: "",
            cash_prize_amount: "",
            joinAfterStart: false,
            privatePortfolio: false,
            cashLeague: false,
          });
          setImages([]);
          setErrors({});
          // navigate("/contest/my-games");
          localStorage.removeItem("imageGame");
          navigate("/contest/my-games", { state: { viewMode: "member" } });
        } else {
          throw new Error("Something went wrong");
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
        console.error("Failed to create game", error);
      }
    }
  };

  return (
    <div className="">
      <div className="bg-white">
        {/* <h2 className="text-xl font-semibold inter text-black text-left mb-6 bg-[#F1F5F9] px-8 py-2">
          Add Game
        </h2> */}

        <form onSubmit={handleSubmit}>
          <div className="space-y-4 px-4 md:px-8 pt-10 max-w-[650px]">
            {/* Title */}
            <div className="block md:flex items-center">
              <label
                htmlFor="title"
                className="block md:min-w-52 text-sm font-medium text-black inter"
              >
                League Title<span className="asterisk_input"> </span>
              </label>

              <div>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className={`mt-1 block w-full rounded-md border ${
                    errors.title ? "border-red-500" : "border-gray-300"
                  } p-2`}
                />
                {errors.title && (
                  <div className="text-red-500 text-sm mt-1">
                    {errors.title}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="space-y-4 px-4 md:px-8 py-10 max-w-[1050px]">
            {/* Description */}
            <div className="block md:flex custom_description">
              <label
                htmlFor="description"
                className="block md:min-w-52 mt-4 text-sm font-medium text-black inter"
              >
                {" "}
                Description:{" "}
              </label>
              <div className="w-full">
                {/* <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleDescriptionChange}
                className={`mt-1 block w-full rounded-md border ${
                  errors.description ? "border-red-500" : "border-gray-300"
                } p-2`}
                rows={3}
              /> */}

                <ReactQuill
                  theme="snow"
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleDescriptionChange}
                  style={{ minHeight: "400px" }}
                  className={`mt-1 block w-full rounded-md border ${
                    errors.description ? "border-red-500" : "border-gray-300"
                  } p-2`}
                />

                {errors.description && (
                  <div className="text-red-500 text-sm mt-1 ">
                    {errors.description}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="space-y-4 px-4 md:px-8 py-10 max-w-[650px]">
            <div className="block md:flex items-center">
              <p className="block md:min-w-52 text-sm font-medium text-black inter">
                {t("Add Images/Videos")}
              </p>
              {/* Game Image*/}
              <div className="block w-full mt-1">
                {flutter ? (
                  <div className={isMobileView ? "md:w-1/3" : "md:w-1/3"}>
                    <label
                      htmlFor="upload"
                      onClick={() => event("imageUploadGame")}
                      className="block text-center rounded-xl border border-2 border-gray-400 cursor-pointer"
                    >
                      <input
                        type="file"
                        id="upload"
                        accept="image/*"
                        multiple
                        onChange={handleImageUpload}
                        className="hidden"
                        disabled={true}
                      />
                      <span className="text-gray-400 text-6xl font-normal">
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ fontWeight: "300" }}
                        />
                      </span>
                    </label>
                  </div>
                ) : (
                  <div
                    className={isMobileView ? "md:w-1/3" : "md:w-1/3 border-r"}
                  >
                    <label
                      htmlFor="upload"
                      className="block text-center py-3 rounded-xl border border-2 border-gray-400 cursor-pointer"
                    >
                      <input
                        type="file"
                        id="upload"
                        accept="image/*,video/*"
                        multiple
                        onChange={handleImageUpload}
                        className="hidden"
                      />

                      <span className="text-gray-400 text-6xl font-normal">
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ fontWeight: "300" }}
                        />
                      </span>
                    </label>
                  </div>
                )}
                <div className="md:w-2/3 flex flex-wrap">
                  {loading && <Loader />}
                  {images.map((img, index) => {
                    return (
                      <div key={index} className="w-full md:w-1/3 p-4 relative">
                        {img?.blob?.name ? (
                          <>
                            {videoExtensionsRegex.test(img?.blob?.name) ? (
                              <>
                                <div className="relative">
                                  <video
                                    autobuffer
                                    playsInline={true}
                                    webkit-playsinline="true"
                                    x5-playsinline="true"
                                    x-webkit-airplay="deny"
                                    disablePictureInPicture={true}
                                    controlsList="nodownload"
                                    onContextMenu={(e) => e.preventDefault()}
                                    preload="auto"
                                    id={`video-${index}`}
                                    controls
                                    className="w-full h-52 rounded-lg"
                                    onClick={(e) => {
                                      // Reset video playback to start from 0 seconds
                                      e.target.currentTime = 0;
                                      // Handle play click event
                                      handlePlayClick(index);
                                    }}
                                  >
                                    <source src={img?.preview} />
                                  </video>
                                  {isMobileView ? (
                                    ""
                                  ) : (
                                    <button
                                      id={`play-button-${index}`}
                                      className="absolute rounded-lg inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white"
                                      style={{ display: "block" }}
                                      onClick={() => handlePlayClick(index)}
                                    >
                                      <FontAwesomeIcon
                                        className="h-7"
                                        icon={faPlay}
                                      />
                                    </button>
                                  )}
                                </div>
                                <button
                                  onClick={() => handleRemoveImage(index)}
                                  className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                                >
                                  &times;
                                </button>
                              </>
                            ) : (
                              <>
                                <img
                                  src={img?.preview}
                                  alt={`Preview ${index}`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                  }}
                                />
                                <button
                                  onClick={() => handleRemoveImage(index)}
                                  className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                                >
                                  &times;
                                </button>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {videoExtensionsRegex.test(img?.preview) ? (
                              <>
                                <div className="relative">
                                  <video
                                    autobuffer
                                    playsInline={true}
                                    webkit-playsinline="true"
                                    x5-playsinline="true"
                                    x-webkit-airplay="deny"
                                    disablePictureInPicture={true}
                                    controlsList="nodownload"
                                    onContextMenu={(e) => e.preventDefault()}
                                    preload="auto"
                                    id={`video-${index}`}
                                    controls
                                    className="w-full h-52 rounded-lg"
                                    onClick={(e) => {
                                      // Reset video playback to start from 0 seconds
                                      e.target.currentTime = 0;
                                      // Handle play click event
                                      handlePlayClick(index);
                                    }}
                                  >
                                    <source src={img?.preview} />
                                  </video>
                                  {isMobileView ? (
                                    ""
                                  ) : (
                                    <button
                                      id={`play-button-${index}`}
                                      className="absolute inset-0 rounded-lg flex items-center justify-center bg-black bg-opacity-50 text-white"
                                      style={{ display: "block" }}
                                      onClick={() => handlePlayClick(index)}
                                    >
                                      <FontAwesomeIcon
                                        className="h-7"
                                        icon={faPlay}
                                      />
                                    </button>
                                  )}
                                </div>
                                <button
                                  onClick={() => handleRemoveImage(index)}
                                  className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                                >
                                  &times;
                                </button>
                              </>
                            ) : (
                              <>
                                <img
                                  src={img?.preview}
                                  alt={`Preview ${index}`}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                  }}
                                />
                                <button
                                  onClick={() => handleRemoveImage(index)}
                                  className="absolute top-0 right-0 m-2 p-1 bg-[#004c50] rounded-full h-6 w-6 flex items-center justify-center text-white cursor-pointer"
                                >
                                  &times;
                                </button>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
                <p className="text-black-500 text-xs mt-1">
                  Supports: JPG, PNG, SVG, WEBP, GIF | MP4, MOV, AVI, WMV <br />
                  (Images ≤ 2MB, Videos ≤ 20MB)
                </p>
              </div>
            </div>

            {/* Start Date */}
            <div className="block md:flex items-center">
              <label
                htmlFor="startDate"
                className="block md:min-w-52 text-sm font-medium text-black inter"
              >
                Date<span className="asterisk_input"> </span>
              </label>
              <div className="block md:flex gap-3 items-center">
                <div>
                  <input
                    type="date" // Changed from datetime-local to date
                    id="startDate"
                    name="startDate"
                    value={formData.startDate}
                    onChange={handleChange}
                    min={isEditMode ? undefined : getTodayDate()} // Prevent selecting past dates
                    className={`mt-1 block w-full rounded-md border ${
                      errors.startDate ? "border-red-500" : "border-gray-300"
                    } p-2`}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  {errors.startDate && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.startDate}
                    </div>
                  )}
                </div>
                {/* End Date */}

                <label
                  htmlFor="endDate"
                  className="text-sm font-medium text-black inter"
                >
                  to
                </label>
                <div>
                  <input
                    type="date" // Changed from datetime-local to date
                    id="endDate"
                    name="endDate"
                    value={formData.endDate}
                    onChange={handleChange}
                    min={formData.startDate || getTodayDate()} // Prevent selecting dates before the start date
                    className={`mt-1 block w-full rounded-md border ${
                      errors.endDate ? "border-red-500" : "border-gray-300"
                    } p-2`}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  {errors.endDate && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.endDate}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Reward */}
            <div className="block md:flex items-center">
              <label
                htmlFor="reward"
                className="block md:min-w-52 text-sm font-medium text-black inter"
              >
                Reward:
              </label>
              <input
                type="text"
                id="reward"
                name="reward"
                value={formData.reward}
                onChange={handleChange}
                className={`mt-1 block w-full rounded-md border min-h-20 ${
                  errors.reward ? "border-red-500" : "border-gray-300"
                } p-2`}
              />
              {errors.reward && (
                <div className="text-red-500 text-sm mt-1">{errors.reward}</div>
              )}
            </div>

            {/* Sponsor */}
            <div className="block md:flex items-center">
              <label
                htmlFor="sponsor"
                className="block md:min-w-52 text-sm font-medium text-black inter"
              >
                Sponsored:
              </label>
              <input
                type="text"
                id="sponsor"
                name="sponsor"
                value={formData.sponsor}
                onChange={handleChange}
                className="mt-1 block w-full md:w-full text-sm border border-gray-300 rounded-md p-2"
              />
            </div>

            <div className="block md:flex items-center">
              <label
                htmlFor="vanity_url"
                className="block md:min-w-52 text-sm font-medium text-black inter"
              >
                Vanity Url:
              </label>
              <div>
                <input
                  type="text"
                  id="vanity_url"
                  name="vanity_url"
                  value={formData.vanity_url}
                  onChange={handleChange}
                  className="mt-1 block w-full md:w-full text-sm border border-gray-300 rounded-md p-2"
                />

                {vanityUrlError && (
                  <div className="text-red-500 text-sm mt-1">
                    {vanityUrlError}
                  </div>
                )}
              </div>
            </div>

            {/* Game Type */}
            <div className="block md:flex items-center">
              <label
                htmlFor="gameType"
                className="block md:min-w-52 text-sm font-medium text-black inter"
              >
                League Type:
              </label>
              <select
                id="gameType"
                name="gameType"
                value={formData.gameType}
                onChange={handleChange}
                className={`mt-1 block w-full rounded-md border bg-transparent ${
                  errors.gameType ? "border-red-500" : "border-gray-300"
                } p-2`}
              >
                <option value="public">Public</option>
                <option value="private">Private</option>
              </select>
            </div>

            {/* Password (for Private Games) */}
            {/* {formData.gameType === "private" && (
              <div className="block md:flex items-center">
                <label
                  htmlFor="password"
                  className="block md:min-w-52 text-sm font-medium text-black inter"
                >
                  Password (for private League):
                </label>
                <div>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className={`mt-1 block w-full rounded-md border ${
                      errors.password ? "border-red-500" : "border-gray-300"
                    } p-2`}
                    placeholder={isEditMode ? "Enter new password" : "Enter password" }
                  />
                  {errors.password && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.password}
                    </div>
                  )}
                </div>
              </div>
            )} */}

            {formData.gameType === "private" && (
              <div className="block md:flex items-center">
                <label
                  htmlFor="password"
                  className="block md:min-w-52 text-sm font-medium text-black inter"
                >
                  Password (for private League):
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className={`mt-1 block w-full rounded-md border ${
                      errors.password ? "border-red-500" : "border-gray-300"
                    } p-2 pr-10`}
                    placeholder={
                      isEditMode ? "Enter new password" : "Enter password"
                    }
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
                  >
                    {showPassword ? IconEyeOpen : IconEyeClose}
                  </button>
                  {errors.password && (
                    <div className="text-red-500 text-sm mt-1">
                      {errors.password}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Credit */}
            {/* <div>
            <label htmlFor="credit" className="block text-sm font-medium text-gray-700">
              Credit:
            </label>
            <input
              type="number"
              id="credit"
              name="credit"
              value={formData.credit}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border ${
                errors.credit ? "border-red-500" : "border-gray-300"
              } p-2`}
            />
            {errors.credit && <div className="text-red-500 text-sm mt-1">{errors.credit}</div>}
          </div> */}

            {/* Join After Start */}
            <div className="block md:flex items-center gap-8 py-4">
              <ToggleSwitch
                name="joinAfterStart"
                checked={formData.joinAfterStart}
                handleChange={handleChange}
              />

              {/* Private Portfolio */}
              {/* <div className="flex items-center">
              <input
                type="checkbox"
                id="privatePortfolio"
                name="privatePortfolio"
                checked={formData.privatePortfolio}
                onChange={handleChange}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label
                htmlFor="privatePortfolio"
                className="ml-2 block text-sm text-black"
              >
                Private portfolio
              </label>
            </div> */}
            </div>

            <div className="block md:flex items-center gap-8 py-4">
              {/* Toggle for "Private Portfolio" */}
              <ToggleSwitch
                name="privatePortfolio"
                checked={formData.privatePortfolio}
                handleChange={handleChange}
              />
            </div>

      {cashUserData?.status && (
        <div className="block items-center gap-8 py-4">
          <ToggleSwitch
            name="cashLeague"
            checked={formData.cashLeague}
            handleChange={handleChange}
            cash_prize_amount={formData.cash_prize_amount}

          />
        </div>
      )}
            {/* Submit Button */}
            <div className="text-center">
              <button
                type="submit"
                className="py-2 px-4 border border-primaryColor bg-primaryColor rounded-full text-gray-200 justify-end text-sm ml-0 md:mr-14"
              >
                {isEditMode ? "Update" : "Create League"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddGame;
